const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');


/**
 * 
 * @readonly
 */
const DIVECE_OPT = {
    type: 'sensor'
};

const BLE_CONFIG = {
    prefix: 'yiPlug',
    SERVICE_UUID: 0x01FF,
    SWITCH_UUID: 0x0206,
    EFF_UUID: 0x0208,
    CUR_UUID: 0x020A,
    VOL_UUID: 0x0209,
    PWR_UUID: 0x020C,
    WORK_STATUS_UUID: 0x020D,
    VERSION_UUID: 0x020E,
    HOLD_UUID: 0x0211,
    WIFI_STATUS_UUID: 0x0203,
}
/**
 * Manage communication with a Arduino esp32 peripheral over a Scratch Link client socket.
 */
class yiPlug extends SensorPeripheral {
    /**
     * Construct a Arduino communication object.
     * @param {Runtime} runtime - the Scratch runtime
     * @param {string} deviceId - the id of the extension
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DIVECE_OPT);
    }
}

class ScratchyiPlugDevice {

    /**
     * @return {string} - the ID of this deivce.
     */
    get DEVICE_ID() {
        return 'yiPlug';
    }

    /**
     * Construct a set of Arduino blocks.
     * @param {Runtime} runtime - the Scratch runtime.
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, originalDeviceId) {
        /**
         * The Scratch runtime.
         * @type {Runtime}
         */
        this.runtime = runtime;

        
        this._peripheral = new yiPlug(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
    }

    getInfo() {
        return [{
            id: 'yiPlug',
            name: formatMessage({
                id: 'yiPlug.categoryName',
                default: 'Smart Plugin',
                description: 'Label for the yi Plug extension category'
            }),
            color1: "#4CAF50",
            color2: "#47A94A",
            color3: "#429E44",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'yiPlug.ble.connect',
                        default: 'connect to yiPlug-[DEVICE_NAME]',
                        description: 'Connect to yiPlug'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'isConnected',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'yiPlug.ble.connected',
                        default: 'isConnected to device?',
                        description: 'isConnected to yiPlug?'
                    })
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'yiPlug.ble.disconnect',
                        default: 'disconnect from yiPlug',
                        description: 'Disconnect from yiPlug'
                    })
                },
                {
                    opcode: 'setPluginSwitch',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'yiPlug.setPluginSwitch',
                        default: 'turn plug [SWITCH]',
                        description: 'Turn plugin on or off'
                    }),
                    arguments: {
                        SWITCH: {
                            type: ArgumentType.NUMBER,
                            menu: 'pluginSwitch'
                        }
                    }
                },
                {
                    opcode: 'getPluginSwitch',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'yiPlug.getPluginSwitch',
                        default: 'switch on?',
                        description: 'Get switch status'
                    })
                },
                {
                    opcode: 'getElectricity',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'yiPlug.getElectricity',
                        default: 'get electricity',
                        description: 'get current electricity'
                    })
                },
                {
                    opcode: 'getVoltage',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'yiPlug.getVoltage',
                        default: 'get voltage',
                        description: 'get current voltage'
                    })
                },
                {
                    opcode: 'getPower',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'yiPlug.getPower',
                        default: 'get power',
                        description: 'get current power'
                    })
                },
                {
                    opcode: 'getVersion',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'yiPlug.getVersion',
                        default: 'get version',
                        description: 'get current version'
                    })
                },
                // {
                //     opcode: 'getWifiStatus',
                //     blockType: BlockType.REPORTER,
                //     text: formatMessage({
                //         id: 'yiPlug.getWifiStatus',
                //         default: 'get Wifi Status',
                //         description: 'get Wifi Status'
                //     })
                // },
                {
                    opcode: 'setHold',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'yiPlug.setHold',
                        default: 'set Power-off retention [HOLD_SWITCH]',
                        description: 'set Power-off retention on or off'
                    }),
                    arguments: {
                        HOLD_SWITCH: {
                            type: ArgumentType.NUMBER,
                            menu: 'holdSwitch'
                        }
                    }
                },
                {
                    opcode: 'getHold',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'yiPlug.getHold',
                        default: 'Power-off retention status is on?',
                        description: 'Get Power-off retention status'
                    })
                },
            ],
            menus: {
                pluginSwitch: {
                    acceptReporters: true,
                    items: [
                        {
                            text: formatMessage({
                                id: 'yiPlug.setPluginSwitch.1',
                                default: 'On',
                                description: 'Plugin switch on'
                            }), value: '1'
                        },
                        {
                            text: formatMessage({
                                id: 'yiPlug.setPluginSwitch.0',
                                default: 'Off',
                                description: 'Plugin switch off'
                            }), value: '0'
                        }
                    ]
                },
                holdSwitch: {
                    acceptReporters: true,
                    items: [
                        {
                            text: formatMessage({
                                id: 'yiPlug.setHold.1',
                                default: 'On',
                                description: 'hold on'
                            }), value: '1'
                        },
                        {
                            text: formatMessage({
                                id: 'yiPlug.setHold.0',
                                default: 'Off',
                                description: 'hold off'
                            }), value: '0'
                        }
                    ]
                }
            }
        }];
    }

    async connect(args) {
        const deviceName = 'yiPlug-'+(args.DEVICE_NAME?.trim() || "");
        console.log(`Connecting to yiPlug device: ${deviceName}`);
        try {
            await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
            console.log(`Connected to device: ${deviceName}`);

        } catch (error) {
            console.error(`Failed to connect to ${deviceName}:`, error);
        }
    }

    async disConnect() {
        console.log('Disconnecting from yiPlug device');
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    async isConnected() {
        console.log('Checking if device is connected');
        return this.bleUtils.device !== null && this.bleUtils.device.gatt.connected;
    }

    async setPluginSwitch(args) {
        const state = args.SWITCH;
        console.log(`Turning plugin ${state === '1' ? 'on' : 'off'}`);
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.SWITCH_UUID);
                const stateValue = parseInt(state, 10);
                if (isNaN(stateValue)) {
                    console.error('Invalid state value:', state);
                    return;
                }
                const stateArray = new Uint8Array(1);
                stateArray[0] = stateValue;
                await this.bleUtils.writeCharacteristic(characteristic, stateArray);
            } catch (error) {
                console.error('Failed to set plugin switch:', error);
            }
        }
    }

    async getElectricity() {
        console.log('Getting electricity value');
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.CUR_UUID);
                const value = await this.bleUtils.readCharacteristic(characteristic);
                return new DataView(value.buffer).getFloat32(0, true);
            } catch (error) {
                console.error('Failed to get electricity value:', error);
            }
        }
        return null;
    }

    async getVoltage() {
        console.log('Getting voltage value');
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.VOL_UUID);
                const value = await this.bleUtils.readCharacteristic(characteristic);
                return new DataView(value.buffer).getFloat32(0, true);
            } catch (error) {
                console.error('Failed to get voltage value:', error);
            }
        }
        return null;
    }

    async getPower() {
        console.log('Getting power value');
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.PWR_UUID);
                const value = await this.bleUtils.readCharacteristic(characteristic);
                return new DataView(value.buffer).getFloat64(0, true);
            } catch (error) {
                console.error('Failed to get power value:', error);
            }
        }
        return null;
    }

    async getVersion() {
        console.log('Getting version');
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.VERSION_UUID);
                const value = await this.bleUtils.readCharacteristic(characteristic);
                return new TextDecoder().decode(value);
            } catch (error) {
                console.error('Failed to get version:', error);
            }
        }
        return null;
    }

    // async getWifiStatus() {
    //     console.log('Getting WiFi status');
    //     if (this.bleUtils.device) {
    //         try {
    //             const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.WIFI_STATUS_UUID);
    //             const value = await this.bleUtils.readCharacteristic(characteristic);
    //             return new DataView(value.buffer).getUint8(0); // Assuming 8-bit value
    //         } catch (error) {
    //             console.error('Failed to get WiFi status:', error);
    //         }
    //     }
    //     return null;
    // }

    async setHold(args) {
        const state = args.HOLD_SWITCH;
        console.log(`Setting power-off retention to ${state === '1' ? 'on' : 'off'}`);
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.HOLD_UUID);
                const stateValue = parseInt(state, 10);
                if (isNaN(stateValue)) {
                    console.error('Invalid state value:', state);
                    return;
                }
                const stateArray = new Uint8Array(1);
                stateArray[0] = stateValue;
                await this.bleUtils.writeCharacteristic(characteristic, stateArray);
            } catch (error) {
                console.error('Failed to set power-off retention:', error);
            }
        }
    }

    async getPluginSwitch() {
        console.log('Getting plugin switch status');
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.SWITCH_UUID);
                const value = await this.bleUtils.readCharacteristic(characteristic);
                return new DataView(value.buffer).getUint8(0) === 1; // Assuming 1 is on, 0 is off
            } catch (error) {
                console.error('Failed to get plugin switch status:', error);
            }
        }
        return false;
    }

    async getHold() {
        console.log('Getting power-off retention status');
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.HOLD_UUID);
                const value = await this.bleUtils.readCharacteristic(characteristic);
                return new DataView(value.buffer).getUint8(0) === 1; // Assuming 1 is on, 0 is off
            } catch (error) {
                console.error('Failed to get power-off retention status:', error);
            }
        }
        return false;
    }
}

module.exports = ScratchyiPlugDevice;